import React, { useEffect } from "react";
import InformationForm from "./InformationForm";
import "../Styles/InformationModal.css";

function InformationModal({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="information_modal_backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="information_modal" role="dialog" aria-modal="true" aria-labelledby="information-modal-title">
        <button className="information_modal_close" type="button" onClick={onClose} aria-label="Close information form">
          <span aria-hidden="true">&#10005;</span>
        </button>
        <p className="information_modal_kicker">Information request</p>
        <h2 id="information-modal-title">Get More Information</h2>
        <p className="information_modal_intro">
          Ask a general question about a PyLoan guide, government scheme or
          document checklist. We will reply with relevant educational
          information or an official source.
        </p>
        <div className="information_modal_notice">
          <i className="fa-solid fa-circle-info" aria-hidden="true"></i>
          <span>
            This form is for information only. PyLoan does not accept, process
            or arrange loan applications.
          </span>
        </div>
        <InformationForm className="modal_information_form" submitLabel="Get information" />
      </div>
    </div>
  );
}

export default InformationModal;
